<x-chartist [type]="'Line'" [data]="smilData" [options]="smilOptions" [events]="smilEvents"
  class="height-300 chart-smil-animations">
</x-chartist>